import { OrderedMap, Record } from 'immutable';

export const SectionType = Record({ id: null, name: null });

const SECTION_TYPES = OrderedMap({
  DialogSection: {
    name: 'Dialog',
  },
  QuestionSection: {
    name: 'Questions',
  },
  MediaSection: {
    name: 'Media',
  },
  ArticleSection: {
    name: 'Article',
  },
  VocabSection: {
    name: 'Vocabulary',
  },
  PdfSection: {
    name: 'Pdf Section',
  },
  Section: {
    name: 'Basic Section',
  },
}).map((attributes, id) => SectionType({ ...attributes, id }));

export const DIALOG_SECTION = SECTION_TYPES.get('DialogSection');
export const QUESTION_SECTION = SECTION_TYPES.get('QuestionSection');
export const MEDIA_SECTION = SECTION_TYPES.get('MediaSection');
export const ARTICLE_SECTION = SECTION_TYPES.get('ArticleSection');
export const VOCAB_SECTION = SECTION_TYPES.get('VocabSection');
export const PDF_SECTION = SECTION_TYPES.get('PdfSection');
export const BASIC_SECTION = SECTION_TYPES.get('Section');

export default SECTION_TYPES;
